<template lang="pug">
div
  .container-cards
    .cards
      app-card-dashboard(@clickCard="setFiltro({})" :clickable="true" title="Quantidade total de demandas" :content="quantitativo.totalDemandas || '0'" icon="fal fa-file-chart-line" color="#00537C")
      app-card-dashboard(@clickCard="setFiltro({estados:[{id:2}]})" :clickable="true" title="Demandas em andamento" :content="quantitativo.demandasEmAndamento || '0'" icon="fal fa-tasks-alt" color="#FDA764")
      app-card-dashboard(@clickCard="setFiltro({estados:[{id:1}]})" :clickable="true" title="Demandas a serem feitas" :content="quantitativo.demandasAseremFeitas || '0'" icon="fal fa-file-chart-pie" color="#3990FA")
      app-card-dashboard(@clickCard="setFiltro({estados:[{id:3}]})" :clickable="true" title="Demandas concluídas" :content="quantitativo.demandasConcluidas || '0'" icon="fal fa-tasks" color="#11B88B")
      app-card-dashboard(@clickCard="setFiltro({situacoes:['EM_DIA']})" :clickable="true" title="Demandas em dia" :content="quantitativo.demandasEmDia || '0'" icon="fal fa-tasks-alt" color="#BF5FCA")
    .cards
      app-card-dashboard(@clickCard="setFiltro({situacoes:['ATRASADA']})" :clickable="true" title="Demandas atrasadas" :content="quantitativo.demandasAtrasadas || '0'" icon="fal fa-alarm-exclamation" color="#FF5D67")
      app-card-dashboard(@clickCard="setFiltro({situacoes:['A_VENCER']})" :clickable="true" title="Demandas à vencer" :content="quantitativo.demandasAvencer || '0'" icon="fal fa-engine-warning" color="#FFD36B")
      app-card-dashboard(title="Demandas do usuário" :content="quantitativo.demandasUsuario || '0'" icon="fal fa-id-card" color="#585770")
      app-card-dashboard(title="Quantidade de usuários" :content="quantitativo.totalUsuarios || '0'" icon="fal fa-users" color="#62AFE3")
      app-card-dashboard(title="Quantidade de painéis" :content="quantitativo.totalPaineis || '0'" icon="fal fa-project-diagram" color="#00B283")

  el-tabs(type="border-card" tab-position="bottom" @tab-click="tabClick")
    el-tab-pane(:label="LABELS.TODAS_DEMANDAS")
      grafico(
        idDiv="todas_demandas"
        titulo="Demandas"
        v-if="isGraficoAtual(LABELS.TODAS_DEMANDAS)"
        :dados="dadosDemandas"
        keyX="painel"
        keyY="quantidade" keyText="quantidade"
      )
    el-tab-pane(:label="LABELS.DEMANDAS_ATRASADAS")
      grafico(
        idDiv="demandas_atrasadas"
        titulo="Demandas"
        v-if="isGraficoAtual(LABELS.DEMANDAS_ATRASADAS)"
        :dados="dadosDemandas"
        keyX="painel"
        keyY="quantidade"
        keyText="quantidade"
      )
    el-tab-pane(:label="LABELS.DEMANDAS_A_SEREM_FEITAS")
      grafico(
        idDiv="demandas_a_serem_feitas"
        titulo="Demandas"
        v-if="isGraficoAtual(LABELS.DEMANDAS_A_SEREM_FEITAS)"
        :dados="dadosDemandas"
        keyX="painel"
        keyY="quantidade"
        keyText="quantidade"
      )
    el-tab-pane(:label="LABELS.DEMANDAS_EM_ANDAMENTO")
      grafico(
        idDiv="demandas_em_andamento"
        titulo="Demandas"
        v-if="isGraficoAtual(LABELS.DEMANDAS_EM_ANDAMENTO)"
        :dados="dadosDemandas"
        keyX="painel"
        keyY="quantidade"
        keyText="quantidade"
      )
    el-tab-pane(:label="LABELS.DEMANDAS_A_VENCER")
      grafico(
        idDiv="demandas_a_vencer"
        titulo="Demandas"
        v-if="isGraficoAtual(LABELS.DEMANDAS_A_VENCER)"
        :dados="dadosDemandas"
        keyX="painel"
        keyY="quantidade"
        keyText="quantidade"
      )

  .container-tab-grafico-usuario
    el-tabs(type="border-card" tab-position="bottom" @tab-click="onClickTabGraficoUsuario")
      el-tab-pane(:label="LABELS.PAINEL")
        grafico(
          idDiv="usuario_painel"
          titulo="Usuários"
          v-if="isGraficoAtualUsuario(LABELS.PAINEL)"
          :dados="dadosGraficoUsuario"
          keyX="usuario"
          keyY="quantidade"
          keyText="quantidade"
          tituloX="Usuário"
          tituloY="Quantidade de painéis"
        )
      el-tab-pane(:label="LABELS.DEMANDAS")
        grafico(
          idDiv="usuario_demanda"
          titulo="Usuários"
          v-if="isGraficoAtualUsuario(LABELS.DEMANDAS)"
          :dados="dadosGraficoUsuario"
          keyX="usuario"
          keyY="quantidade"
          keyText="quantidade"
          tituloX="Usuário"
        )

  listagem-demandas-relatorio#listagemDemandas(ref="listagemDemandas")

</template>

<script>
import Grafico from '@/screens/demandas/components/Grafico'
import AppCardDashboard from '@/components/AppCardDashboard'
import { mapActions } from 'vuex'
import ListagemDemandasRelatorio from '@/screens/demandas/components/ListagemDemandasRelatorio'

const TODAS_DEMANDAS = 'Todas'
const DEMANDAS_ATRASADAS = 'Atrasadas'
const DEMANDAS_A_SEREM_FEITAS = 'A serem feitas'
const DEMANDAS_EM_ANDAMENTO = 'Em andamento'
const DEMANDAS_A_VENCER = 'A vencer'
const PAINEL = 'Painel'
const DEMANDAS = 'Demandas'

export default {
  components: {
    Grafico,
    AppCardDashboard,
    ListagemDemandasRelatorio
  },

  data () {
    return {
      LABELS: {
        TODAS_DEMANDAS,
        DEMANDAS_ATRASADAS,
        DEMANDAS_A_SEREM_FEITAS,
        DEMANDAS_EM_ANDAMENTO,
        DEMANDAS_A_VENCER,
        PAINEL,
        DEMANDAS
      },
      graficoAtual: null,
      graficoAtualUsuario: null,
      dadosDemandas: [],
      dadosGraficoUsuario: [],
      quantitativo: {
        totalDemandas: null,
        demandasEmAndamento: null,
        demandasAseremFeitas: null,
        demandasConcluidas: null,
        demandasEmDia: null,
        demandasAtrasadas: null,
        demandasAvencer: null,
        demandasUsuario: null,
        totalUsuarios: null,
        totalPaineis: null
      }
    }
  },

  created () {
    this.getQuantitativos()
    this.getDemandas(TODAS_DEMANDAS)
    this.getDadosGraficoUsuario(PAINEL)
  },

  methods: {
    ...mapActions({
      findDemandasTodas: 'relatorios/findDemandasTodas',
      findDemandasAseremFeitas: 'relatorios/findDemandasAseremFeitas',
      findDemandasEmAndamento: 'relatorios/findDemandasEmAndamento',
      findDemandasAtrasadas: 'relatorios/findDemandasAtrasadas',
      findDemandasAvencer: 'relatorios/findDemandasAvencer',
      findDadosGraficoUsuarioPainel: 'relatorios/findDadosGraficoUsuarioPainel',
      findDadosGraficoUsuarioDemandas: 'relatorios/findDadosGraficoUsuarioDemandas',
      findQuantitativo: 'relatorios/findQuantitativo'
    }),

    tabClick (tab) {
      this.getDemandas(tab.label)
    },

    onClickTabGraficoUsuario (tab) {
      this.getDadosGraficoUsuario(tab.label)
    },

    isGraficoAtual (grafico) {
      return this.graficoAtual === grafico
    },

    isGraficoAtualUsuario (grafico) {
      return this.graficoAtualUsuario === grafico
    },

    async getDadosGraficoUsuario (filtro) {
      switch (filtro) {
        case this.LABELS.PAINEL:
          this.dadosGraficoUsuario = await this.findDadosGraficoUsuarioPainel()
          this.graficoAtualUsuario = filtro
          break
        case this.LABELS.DEMANDAS:
          this.dadosGraficoUsuario = await this.findDadosGraficoUsuarioDemandas()
          this.graficoAtualUsuario = filtro
          break
      }
    },

    getQuantitativos () {
      this.findQuantitativo().then((quantitativo) => {
        this.quantitativo = quantitativo
      })
    },

    async getDemandas (filtro) {
      switch (filtro) {
        case this.LABELS.TODAS_DEMANDAS:
          this.dadosDemandas = await this.findDemandasTodas()
          this.graficoAtual = filtro
          break
        case this.LABELS.DEMANDAS_ATRASADAS:
          this.dadosDemandas = await this.findDemandasAtrasadas()
          this.graficoAtual = filtro
          break
        case this.LABELS.DEMANDAS_A_SEREM_FEITAS:
          this.dadosDemandas = await this.findDemandasAseremFeitas()
          this.graficoAtual = filtro
          break
        case this.LABELS.DEMANDAS_EM_ANDAMENTO:
          this.dadosDemandas = await this.findDemandasEmAndamento()
          this.graficoAtual = filtro
          break
        case this.LABELS.DEMANDAS_A_VENCER:
          this.dadosDemandas = await this.findDemandasAvencer()
          this.graficoAtual = filtro
          break
      }
    },

    setFiltro (filtro) {
      this.$refs.listagemDemandas.setFiltro(filtro)
      this.$scrollTo('#listagemDemandas')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tab-pane {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 450px;
}

.container-tab-grafico-usuario {
  margin-top: 50px;
}

.container-cards {
  padding: 20px;
}

.cards {
  display: flex;
}

.card-dashboard:first-child {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/Relatorios.vue